import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
const Minimap = observer(function ({ model }) {
    const [mouseDown, setMouseDown] = useState();
    const scheduled = useRef(false);
    const [hovered, setHovered] = useState(false);
    const { scrollX, msaAreaWidth: W, minimapHeight: H, colWidth, numColumns, } = model;
    const unit = W / numColumns / colWidth;
    const left = -scrollX;
    const right = left + W;
    const s = left * unit;
    const e = right * unit;
    const fill = 'rgba(66, 119, 127, 0.3)';
    useEffect(() => {
        if (mouseDown !== undefined) {
            function fn(event) {
                if (mouseDown !== undefined) {
                    if (!scheduled.current) {
                        scheduled.current = true;
                        window.requestAnimationFrame(() => {
                            model.setScrollX(mouseDown.scrollX - (event.clientX - mouseDown.clientX) / unit);
                            scheduled.current = false;
                        });
                    }
                }
            }
            function fn2() {
                setMouseDown(undefined);
            }
            document.addEventListener('mousemove', fn);
            document.addEventListener('mouseup', fn2);
            return () => {
                document.removeEventListener('mousemove', fn);
                document.removeEventListener('mousemove', fn2);
            };
        }
    }, [model, unit, mouseDown]);
    const BAR_HEIGHT = 12;
    const H2 = H - 12;
    return (React.createElement("div", { style: { position: 'relative', height: H, width: '100%' } },
        React.createElement("div", { style: {
                boxSizing: 'border-box',
                height: BAR_HEIGHT,
                border: '1px solid #555',
            } }),
        React.createElement("div", { style: {
                position: 'absolute',
                top: 0,
                left: Math.max(0, s),
                background: hovered ? 'rgba(66,119,127,0.6)' : fill,
                cursor: 'pointer',
                border: '1px solid #555',
                boxSizing: 'border-box',
                height: BAR_HEIGHT,
                width: e - s,
                zIndex: 100,
            }, onMouseOver: () => setHovered(true), onMouseOut: () => setHovered(false), onMouseDown: event => {
                setMouseDown({
                    clientX: event.clientX,
                    scrollX: model.scrollX,
                });
            } }),
        React.createElement("svg", { height: H2, style: { width: '100%' } },
            React.createElement("polygon", { fill: fill, points: [
                    [e, 0],
                    [s, 0],
                    [0, H2],
                    [W, H2],
                ].toString() }))));
});
export default Minimap;
//# sourceMappingURL=Minimap.js.map